import React from "react";
import cn from "classnames";
import style from "./style.module.scss";

const TreasureTitle: React.FC = () => {
  return <div className={cn("text default", style.root)}>Treasure</div>;
};

export default TreasureTitle;
